import React from "react";
import { Figure, Card } from "react-bootstrap";
import Gorra from "../Assets/diamante.png";

function CardTicket({
  cantidad,
  valor,
  featured = false,
  featuredText = "Opcion mas comprada",
  selected = false,
  disabled = false,
  onSelect,
  badgeText,
  borderColor,
}) {
  const handleSelect = () => {
    if (!disabled && onSelect) {
      onSelect(cantidad);
    }
  };

  const handleKeyDown = (event) => {
    if (disabled) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSelect();
    }
  };

  function hexToRgb(hex) {
    if (!hex) return null;
    const clean = hex.replace('#','');
    const full = clean.length === 3 ? clean.split('').map(c=>c+c).join('') : clean;
    const bigint = parseInt(full, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  }

  const rgb = hexToRgb(borderColor);
  const cardStyle = {
    border: borderColor ? `2px solid ${borderColor}` : undefined,
    borderRadius: "12px",
    cursor: disabled ? "default" : "pointer",
    boxShadow: borderColor && rgb ? `0 12px 30px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.12)` : undefined,
    transform: borderColor ? 'translateY(-6px)' : undefined,
  };

  const showBadge = Boolean(badgeText) || featured;
  const badgeContent = badgeText || featuredText;
  const badgeStyle = {
    backgroundColor: borderColor || undefined,
    color: "#fff",
    marginLeft: "auto",
  };

  return (
    <Card
      className={`mb-4 shadow-sm ticket-option ${featured ? "featured" : ""} ${selected ? "ticket-option-selected" : ""} ${showBadge ? "has-badge" : ""}`}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-pressed={selected}
      aria-disabled={disabled}
      style={{ ...cardStyle, position: "relative" }}
    >
      {showBadge && (
        featured && !badgeText ? (
          <div className="featured-badge">{badgeContent}</div>
        ) : (
          <div className="ticket-badge" style={badgeStyle}>{badgeContent}</div>
        )
      )}

      <Card.Body>

        <div className="card-compact">
          <Figure className="card-compact-figure">
            <Figure.Image width={80} height={80} alt="Diamante" src={Gorra} />
          </Figure>

          <div className="card-compact-text">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "24px",
                justifyContent: "center",
              }}
            >
              <Card.Text className="card-price" style={{ margin: 0 }}>
                {Number(valor).toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </Card.Text>

              <h2 style={{ margin: 0 }}>X{cantidad}</h2>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default CardTicket;
